export { default as TypographyWithSkeleton } from './TypographyWithSkeleton';
